// extracted by mini-css-extract-plugin
export default {"content":"content_SfUrf","top":"top_XeuFV","right":"right_MLCcd","bottom":"bottom_AEM3W","left":"left_zizb9","holder":"holder_OkljF"};